import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

export default function UserTaskHistory() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState();
  const [TotalAmount, setTotalAmount] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/GetTaskHistory",
        {
          loginid: userId,
          uid: search,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("acfundhis-->", responceRight);
      setTotalAmount(responceRight?.data?.TotalAmount);
      responceRight = responceRight.data.data[0];

      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          rowNumber: item.row,
          user_id: `${item?.Userid} `,
          taskcount: `${item?.seenad} `,
          remaintask: item?.unseenad,
          totaltask: item?.total_task,
          TaskDate: item?.dd,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, [search]);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "rowNumber" },
      { Header: "User ID", accessor: "user_id" },
      { Header: "Completed Task", accessor: "taskcount" },
      { Header: "Remaining Task", accessor: "remaintask" },
      { Header: "Total Task", accessor: "totaltask" },
      { Header: "Created Task Date", accessor: "TaskDate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">User Task History</h4>
                </div>
                <div class="panel-body">
                  <div class="row"></div>
                  <div class="row">
                    <div className="form-group">
                      <label>User Id</label>
                      <input
                        type="text"
                        id="txtuid"
                        class="form-control"
                        placeholder="Enter Task Url"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
